/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import TagManager from 'react-gtm-module';
import AnalyticsChannelBase from './AnalyticsChannelBase';
import { AnalyticsError } from './AnalyticsConfig';

export default class AnalyticsChannelGTM extends AnalyticsChannelBase {
  private dataLayer;

  constructor() {
    // log only conversion events, no errors
    super(['navigation.banner', 'navigation.pwa_offer', 'navigation.pwa_prompt', 'settings.mode', 'navigation.product_recommendation'], []);

    if (process.env.REACT_APP_GTM_ID) {
      TagManager.initialize({
        gtmId: process.env.REACT_APP_GTM_ID,
      });
      this.dataLayer = (window as any).dataLayer;
      if (!this.dataLayer) {
        console.error('Failed to init AnalyticsChannelGTM: no dataLayer found');
      }
    } else {
      console.error('Failed to init AnalyticsChannelGTM: invalid GTM ID');
    }
  }

  protected _log(category: string, action: string, value?: number, label?: string, additional?: string | number) {
    // log only advanced mode, not going back to the basic mode
    if (category === 'settings' && action === 'mode' && label === 'basic') {
      return;
    }
    // console.log(`AnalyticsChannelGTM._log(): ${category} / ${action} / ${label ?? '-'} / ${additional ?? '-'} / ${value ?? '-'}`);
    this.dataLayer.push({
      event: 'event',
      eventProps: {
        category: category,
        action: action,
        label: label,
        value: value,
      },
    });
  }

  protected _error(type: AnalyticsError, message?: string) {
    const action = type.split('.')[1];
    console.warn(`NOT IMPLEMENTED: AnalyticsChannelGTM._error(): ${type} / ${action} / ${message ?? '-'}`);
  }
}
